const faceImgList = [
    {
        title: '微笑',
        name: 'smile',
    },
    {
        title: '皱眉',
        name: 'frown',
    },
    {
        title: '色色',
        name: 'lechery',
    },
    {
        title: '哭泣',
        name: 'cry',
    },
    {
        title: '龇牙',
        name: 'teethlaugh',
    },
    {
        title: '晕',
        name: 'dizzy',
    },
    {
        title: '傲慢',
        name: 'arrogant',
    },
    {
        title: '抠鼻',
        name: 'dignose',
    },
    {
        title: '欢呼',
        name: 'cheer',
    },
    {
        title: '害羞',
        name: 'shy',
    },
    {
        title: '拍击',
        name: 'slap',
    },
    {
        title: '酷',
        name: 'cool',
    },
    {
        title: '捂脸哭',
        name: 'facepalmcry',
    },
    {
        title: '生气',
        name: 'angry',
    },
    {
        title: '困',
        name: 'sleepy',
    },
    {
        title: '疑问',
        name: 'doubt',
    },
    {
        title: '可怜',
        name: 'pathetic',
    },
    {
        title: '呕吐',
        name: 'vomit',
    },
    {
        title: '笑哭',
        name: 'laughcry',
    },
    {
        title: '偷笑',
        name: 'titter',
    },
    {
        title: '奸笑',
        name: 'comic',
    },
    {
        title: '反笑',
        name: 'reversesmile',
    },
    {
        title: '抓狂',
        name: 'crazy',
    },
    {
        title: '错愕',
        name: 'astonished',
    },
    {
        title: '大哭',
        name: 'bigcry',
    },
    {
        title: '奋斗',
        name: 'struggle',
    },
    {
        title: '邪恶',
        name: 'evil',
    },
    {
        title: '尴尬',
        name: 'awkward',
    },
    {
        title: '闭嘴',
        name: 'shutup',
    },
    {
        title: '生病',
        name: 'fallill',
    },
    {
        title: '爱心',
        name: 'heart',
    },
    {
        title: '拥抱',
        name: 'embrace',
    },
    {
        title: '摊手',
        name: 'letgo',
    },
    {
        title: '喜欢',
        name: 'like',
    },
    {
        title: '握手',
        name: 'handshake',
    },
    {
        title: 'OK',
        name: 'ok',
    },
    {
        title: '鼓掌',
        name: 'applause',
    },
    {
        title: '点赞',
        name: 'praise',
    },
    {
        title: '嘘声',
        name: 'boo',
    },
    {
        title: '祝福',
        name: 'blessing',
    },
    {
        title: '西瓜',
        name: 'watermelon',
    },
    {
        title: '蜡烛',
        name: 'candle',
    },
    {
        title: '狗头',
        name: 'dog',
    },
    {
        title: '不抬杠',
        name: 'dontbicker',
    },
    {
        title: '喝茶',
        name: 'drinktea',
    },
    {
        title: '屎',
        name: 'dung',
    },
    {
        title: '难',
        name: 'hard',
    },
    {
        title: '呵呵',
        name: 'hehe',
    },
    {
        title: '下跪哭',
        name: 'kneelcry',
    },
    {
        title: '下跪',
        name: 'kneel',
    },
    {
        title: '威武',
        name: 'majestic',
    },
    {
        title: '响指',
        name: 'snap',
    },
    {
        title: '裂开',
        name: 'split',
    },
    {
        title: '别说话',
        name: 'stoptalking',
    },
    {
        title: '奋斗',
        name: 'struggle',
    },
];

const oldFaceImgList = [
    {
        title: '衰',
        name: 'wane',
    },
    {
        title: '流汗',
        name: 'sweat',
    },
    {
        title: '睡着',
        name: 'sleep',
    },
    {
        title: '憨笑',
        name: 'simper',
    },
    {
        title: '玫瑰',
        name: 'rose',
    },
    {
        title: '求关注',
        name: 'follow',
    },
    {
        title: '愣',
        name: 'daze',
    },
    {
        title: '可爱',
        name: 'cute',
    },
    {
        title: '天使',
        name: 'angel',
    },
    {
        title: '拜拜',
        name: 'bye',
    },
    {
        title: '惊',
        name: 'amaze',
    },
];

export { faceImgList, oldFaceImgList };
